import { APIConfiguration } from '@savgroup-front-common/configuration';

const DEV_ONBOARDING_HOSTNAME = 'dev-onboarding.revers.io';
const ONBOARDING_PREVIEW_HOSTNAME_SUFFIXES = [
  `.preview.${DEV_ONBOARDING_HOSTNAME}`,
  `.preview-front.${DEV_ONBOARDING_HOSTNAME}`,
];

export function getOnboardingHostname(): string {
  const { hostname } = window.location;
  const isOnboardingPreview = ONBOARDING_PREVIEW_HOSTNAME_SUFFIXES.some(
    (suffix) => hostname.endsWith(suffix),
  );

  return isOnboardingPreview ? DEV_ONBOARDING_HOSTNAME : hostname;
}

const DEV_CONTROL_HOSTNAME = 'dev-app.revers.io';

export function getPreviewControlHostname(): string | null {
  const { hostname } = window.location;
  const isOnboardingPreview = ONBOARDING_PREVIEW_HOSTNAME_SUFFIXES.some(
    (suffix) => hostname.endsWith(suffix),
  );

  return isOnboardingPreview
    ? `${hostname.slice(0, -DEV_ONBOARDING_HOSTNAME.length)}${DEV_CONTROL_HOSTNAME}`
    : null;
}

const PREVIEW_API_BASE = /^https:\/\/([a-z0-9-]+)\.preview\.revers\.io\//;

export function getPreviewApiName(
  apiBase: string = APIConfiguration.base,
): string | null {
  return PREVIEW_API_BASE.exec(apiBase)?.[1] ?? null;
}
